import { Box, Typography, Tooltip } from "@mui/material";
import React, { useState, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { DataTable, NoVisitado } from "../../../components";
import { generarPDF, getSales, getFinca, getSalesProperties, getUrlServs } from "../../../services";
import { toast } from "react-toastify";
import FiltrosComunidadesTechServ from "../../../components/filtros/filtrosComunidadesTechServ";
import { formatoFechasEs, redirigirApp } from "../../../functions/funciones";
import { UsuarioContext } from "../../../providers/userContext";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { FaPencilAlt, FaPlus } from "react-icons/fa";

import { TbCertificate } from "react-icons/tb";
import { IoVideocam } from "react-icons/io5";
import { TiDocumentText } from "react-icons/ti";
import { MdHealthAndSafety } from "react-icons/md";
import { IoIosWarning } from "react-icons/io";
import { HiClipboardDocumentList } from "react-icons/hi2";
import Enlace from "../../../components/Enlace";
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from './../../../functions/parametrosURL/funcionesParamsURL';
import NoVisitadoAAFF from "../../../components/noVisitadoAAFF";
import ExportarListaComunidades from "./ExportarListaComunidades";
import BotonGenerarQR from "../../../components/Buttons/BotonGenerarQR";


const ComunidadesServicio = (props) => {
    const { t } = useTranslation(['properties', 'suppliers', 'common']);

    const { nifFinca, grupoServicio } = props
    const user = useContext(UsuarioContext);
  
  
    const [listaVentas, setListaVentas] = useState([]);
    const [pdfUrl, setPdfUrl] = useState("");
    const { filtrosIniciales, filtroOrder } = useRecogerURLParamsFiltros();
    const tieneFiltrosAplicados = Object.keys(filtrosIniciales).length > 2;
    const [loading, setLoading] = useState(nifFinca !== undefined || tieneFiltrosAplicados);
    const [busquedaIniciada, setBusquedaIniciada] = useState(nifFinca !== undefined || tieneFiltrosAplicados);
    const filterCheckBox = user.rol == "TECH" || user.rol == "TECH_COOR" || user.rol == "ADMIN" ? {...filtrosIniciales,visitasRecientes: false} : filtrosIniciales;
    const [busqueda, setBusqueda] = useState(filterCheckBox);
    const [busquedaActiva, setBusquedaActiva] = useState(false);
    const [recargar, setRecargar] = useState(false);
    const [clearFilterActivo, setClearFilterActivo] = useState(false);
    const [tieneCentro, setTieneCentro] = useState(false);
    const [payload, setPayload] = useState({});
    const [data, setData] = useState({
      meta: {},
      rows: [],
    });
    
    const refControladorAborto = useRef();
  
    const navigate = useNavigate();
    const location = useLocation();
    const anoActual = new Date().getFullYear();

    const clearFilters = () => {
      setBusqueda(user.rol == "TECH" || user.rol == "TECH_COOR" || user.rol == "ADMIN" ? {visitasRecientes: false} : {});
  
      setClearFilterActivo(true);
    }

    const comunidadesRows = [
      {
        id: "color",
        numeric: false,
        disablePadding: true,
        label: "",
        overrideFunc: (row) => (
          <Typography
            className="servicios"
            style={{ width: '3px', height: '6vh', padding: 0, background: row }}
          ></Typography>
        ),
      },
      {
        id: "saleDate",
        numeric: false,
        disablePadding: false,
        label: t('columns.year'),
      },
      
      {
        id: "comunidad",
        numeric: false,
        disablePadding: false,
        label: t('columns.community'),
        noObjeto: true,
        overrideFunc: (data, row) => (
          <Link to={`/comunidades/${row.finca.nif}`}>
            {data}
          </Link>
        )
      },
      {
        id: "nif",
        numeric: false,
        disablePadding: false,
        label: t('common:form.nif').toUpperCase(),
        noObjeto: true,
        overrideFunc: (data, row) => (
          <Typography
            style={{ width: '100px', textAlign: 'center' }}>
            {data}
          </Typography>
        ),
      },
      {
        id: "servicio",
        numeric: false,
        disablePadding: false,
        label: t('columns.service'),
        noObjeto: true,
      },
      // {
      //   id: "createdAt",
      //   numeric: false,
      //   disablePadding: false,
      //   label: "FECHA VENTA",
      //   overrideFunc: (data) => formatoFechasEs(data),
      // },
      {
        id: "documentos",
        numeric: false,
        disablePadding: false,
        label: t('columns.documents'),
        colSpan: 4,
        noObjeto: true,
        overrideFunc: (row) => (
          <Typography style={{ display: 'flex', gap: 5, color: '#fff' }}>
            {(row.serviceprops.id === 1 || row.serviceprops.id === 3 || row.serviceprops.id === 6 || row.serviceprops.id === 7) && (
              <>
                {renderDocs(t('common:services.documents.visitSheet'), <HiClipboardDocumentList />, "hoja-visita", row, "cae")}
                {renderDocs(t('common:services.documents.riskIdentification'), <MdHealthAndSafety />, "identificacion-riesgos", row, "cae")}
                {renderDocs(t('common:services.documents.emergencyMeasures'), <IoIosWarning />, "medidas-emergencia", row, "cae")}
              </>
            )}
            {(row.serviceprops.id === 2 || row.serviceprops.id === 4) && (
              <>
                {renderDocs(t('common:services.documents.certificate'), <TbCertificate />, row.serviceprops.id === 4 ? 'certificado-auditoria' : 'certificado-implantacion', row, "lopd")}

                {renderDocs(t('common:services.documents.implementation'), <TiDocumentText />, 'documentacion-implantacion', row, "lopd")}

                {row.serviceprops.id === 4 ?
                  renderDocs(t('common:services.documents.audit'), <TiDocumentText />, 'documentacion-auditoria', row, "lopd")
                  : null}
                {row.detailsLopd[0]?.surveillanceVideo ? renderDocs(t('common:services.documents.videoSurveillance'), <IoVideocam />, "video-vigilancia", row, "lopd") : ''}
              </>
            )}
            {(row.serviceprops.id === 5) && (
              <>
                {renderDocs(t('common:services.documents.lopd'), <TbCertificate />, 'lopd', row, "lopd")}
              </>
            )}
            {(row.serviceprops.id === 8 || row.serviceprops.id === 9) && (
              <>
                {renderDocs("Certificado", <TbCertificate />, 'certificado-accesibilidad', row, "cai")}
                {renderDocs("Informe", <TiDocumentText />, 'informe-accesibilidad', row, "cai")}
              </>
            )}
          </Typography>
        ),
      },
      // user.rol !== 'AAFF' ?
      // {
      //   id: "noVisita",
      //   numeric: false,
      //   disablePadding: false,
      //   label: "No visitada",
      //   overrideFunc: (row) => (
      //     <Typography>
      //         <NoVisitado finca={row} nif={row.properties.nif} tipo={"finca"} />
      //     </Typography>
      //   ),
      // }:'',
      user.rol !== 'AAFF' ?
        {
          id: "servicioRealizado",
          numeric: false,
          disablePadding: false,
          label: t('columns.serviceRealized'),
          noObjeto: true,
  
          overrideFunc: (row) => (
            <Typography>
              {!row?.detailsCae?.[0]?.unRealized &&
              row?.detailsCae?.[0]?.visitSheet?.visitDate !== null &&
              row?.detailsCae?.[0]?.visitSheet?.visitDate !== undefined
                ? formatoFechasEs(row?.detailsCae?.[0]?.visitSheet?.visitDate)
                : !row.detailsCai?.[0]?.unRealized && 
                row.detailsCai?.[0]?.visitSheetCai?.visitDate !== null && 
                row.detailsCai?.[0]?.visitSheetCai?.visitDate !== undefined 
                ? formatoFechasEs(row.detailsCai?.[0]?.visitSheetCai?.visitDate)
                : row?.docsProps?.[0]?.visitSheet_id == null &&
                  row?.docsProps?.[0]?.ruta
                ? "Ver Informe"
                : null}
            </Typography>
  
          ),
        } : '',
  
  
    ].filter(Boolean);



    const realizarVisita = {
      id: "hacerVisita",
      numeric: false,
      disablePadding: false,
      label: t('columns.makeVisit'),
      noObjeto: true,
      overrideFunc: (row, data) => {
        const esCai = [8, 9].includes(row.serviceprops.id);
        const esCae = [1, 3, 6, 7].includes(row.serviceprops.id);
        const mostrarNoVisitado = (esCai && !row.detailsCai?.[0]?.visitada) ||
          (esCae && (data.saleDate < 2024 || data.tienePendientesEnAno(data.saleDate)));
        const mostrarBotonVisita = esCai || (esCae && (data.saleDate < 2024 || data.tienePendientesEnAno(data.saleDate) || row.previous_unRealized));
        const esTech = user.rol === "TECH";
        const esCoorAsignado = user.rol === "TECH_COOR";
        const tienePermisoEscritura = esTech || esCoorAsignado;
        return (
          <Typography>
            {(user.rol !== 'AAFF' && mostrarNoVisitado) && (
              // La marca de no visita del AAFF solo aplica a las ventas CAE; sin marca, el componente
              // muestra el no visitado de la venta (fallback) y al quitarla cambia sin recargar
              (esCae && row?.detailsCae?.[0]?.visitSheet_id === null)
                ? <NoVisitadoAAFF
                  aaff={row?.aaff}
                  nif={row?.aaff?.nif}
                  servicio="CAE"
                  fallback={<NoVisitado finca={row} nif={row?.properties?.nif} tipo={"finca"} />}
                />
                : <NoVisitado finca={row} nif={row?.properties?.nif} tipo={"finca"} />
            )}

            {tienePermisoEscritura && (
              <>
                {(row.detailsCae?.[0]?.visitada || row.detailsCai?.[0]?.visitada) ? (
                  (row.detailsCae?.[0]?.visitSheet_id || row.detailsCai?.[0]?.visitSheetCai_id) && (
                    <button onClick={() => redirigirApp("edit", row.id, row.saleDate, row.prop_id, row.aaff_id, row.workcenters?.id)} style={{ padding: 5 }} className="btn">
                      <FaPencilAlt />
                    </button>
                  )
                ) : mostrarBotonVisita ? (
                  <button onClick={() => redirigirApp("create", row.id, row.saleDate, row.prop_id, row.aaff_id, row.workcenters?.id)} style={{ padding: 5 }} className="btn">
                    <FaPlus />
                  </button>
                ) : null}
              </>
            )}
          </Typography>
        );
      },
    }

    
    
    comunidadesRows.push(realizarVisita)

    // El QR se puede pegar en la finca antes de la visita, asi que se ofrece siempre.
    // Solo a los tecnicos del piloto del QR
    if ((user.rol === "TECH" || user.rol === "TECH_COOR") && user.puedeUsarQR) {
      comunidadesRows.push({
        id: "generarQR",
        numeric: false,
        disablePadding: false,
        label: t('qr:button.column'),
        noObjeto: true,
        // Sin NIF no habria con que generarlo
        overrideFunc: (valor, fila) => (
          fila?.documentos?.properties?.nif ? (
            <BotonGenerarQR
              nif={fila.documentos.properties.nif}
              workcenterId={fila.documentos.workcenters?.id}
              qrColocado={fila.documentos.workcenters?.qrColocado ?? fila.documentos.properties.qrColocado ?? false}
              omniaHogar={!!fila.documentos.properties.qrOmniaHogar}
            />
          ) : null
        ),
      })
    }
    // useEffect(() => {
    //   const { ano, ...restFiltros } = filtrosIniciales; 
    //   setBusqueda(restFiltros);
    // }, []);

    const enlaceToDocType = {
      'identificacion-riesgos': 'evaluacionRiesgos',
      'hoja-visita': 'hojaVisita',
      'medidas-emergencia': 'planEmergencia',
      'lopd': 'LOPD'
    }
    const renderDocs = (nombre, icono, enlace, row, tipo) => {
  
      let documento;
      let url;
      if (tipo === "lopd" && enlace !== 'lopd') {
        documento = row.detailsLopd?.find(obj => obj.sale_id === row.id);
      }
      if (tipo === "lopd" && enlace === 'lopd') {
        documento = true
      }
      if (tipo === 'cae') {
        documento = row.detailsCae?.find(obj => obj.sale_id === row.id);
      }
      if (tipo === 'cai') {
        documento = row.detailsCai?.find(obj => obj.sale_id === row.id);
      }
  
      if (!documento) {
        return (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: 16 }}>
            <Tooltip title={nombre} style={{ fontSize: '16px' }}>
              <small
                className="docsStatus"
                style={{ background: '#FF5252', height: 'auto' }}
              >
                {icono}
              </small>
            </Tooltip>
          </div>
        );
      }
  
      const { pendiente, visitada } = documento;
  
      if ((tipo === "lopd" && enlace !== 'lopd') ||
        ((tipo === 'cae' || tipo === 'cai') && (pendiente || visitada))) {
        if (row.workcenters === null) {
          url = `/doc-render/${row.properties?.nif}/${row.id}/${enlace}`
        } else {
          url = `/doc-render/${row.properties?.nif}/${row.workcenters.id}/${row.id}/${enlace}`
        }
      }
      if (
      (tipo === "lopd" && enlace === "lopd") ||
      ((tipo === "cae" && !documento?.visitSheet_id) || (tipo === "cai" && !documento?.visitSheetCai_id))
      ) {
        url =
          process.env.REACT_APP_STORAGE_URL +
          row.docsProps?.find((doc) => doc.type === enlaceToDocType[enlace])
            ?.ruta;
      }
      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          {!pendiente && tipo !== 'lopd' && !visitada ?
            <Tooltip title={nombre} style={{ fontSize: '16px' }}>
              <small
                className="docsStatus"
                style={
                  { background: '#FF5252' }
                }
              >
                {icono}
              </small>
            </Tooltip>
            :
            <Tooltip title={nombre} style={{ fontSize: '16px' }}>
              <span >
                <Enlace to={url} target="_blank">
  
                  <small
                    className="docsStatus"
                    style={
                      tipo === 'lopd' || visitada ?
                        { background: '#7bc977' }
                        : pendiente ?
                          { background: '#FCBA03' }
                          : { background: '#FF5252' }
                    }
                  >
                    {icono}
                  </small>
  
                </Enlace>
              </span>
            </Tooltip>
          }
  
        </div>
      );
    };
  
    const convertirAPdf = async ({ nombre, nif, workcenter_id, sale_id }) => {
      try {
        const toastInfo = toast.info(t('common:status.loading'));
        //   const response = await generarPDF(`http://localhost:3001/doc-render/${nif}/${nombre}`);
        const datos = {
          url: workcenter_id !== null ? `http://localhost:3001/doc-render/${nif}/${workcenter_id}/${sale_id}/${nombre}` : `http://localhost:3001/doc-render/${nif}/${sale_id}/${nombre}`,
          nombre: nombre,
          nif: nif
        }
        await generarPDF(datos).then(res => {
          const url = URL.createObjectURL(res.data);
          // Abre el PDF en una nueva ventana o pestaña
          const newWindow = window.open('', '_blank');
          const pdfWindow = newWindow;
          pdfWindow.document.write(t('common:status.loadingPdf'));
  
          // Promesa para cargar la URL
          const loadURL = new Promise((resolve, reject) => {
            const iframe = document.createElement('iframe');
            iframe.src = url;
            iframe.style.display = 'none';
  
            iframe.onload = () => {
              resolve();
            };
  
            iframe.onerror = (error) => {
              reject(error);
            };
  
            document.body.appendChild(iframe);
          });
  
          loadURL
            .then(() => {
              // Espera a que el evento "load" se dispare en el iframe antes de abrir la ventana emergente
              pdfWindow.location.href = 'about:blank'; // Limpiar la página en blanco
              pdfWindow.document.write(t('common:status.loadingPdf'));
              setTimeout(() => {
                pdfWindow.location.href = 'about:blank'; // Limpiar la página en blanco nuevamente
                pdfWindow.location.href = url; // Abrir la URL del PDF
              }, 1000); // Espera 1 segundo (ajusta según sea necesario)
            })
            .catch((error) => {
              console.error('Error al cargar la URL:', error);
              pdfWindow.document.write(t('common:status.loadingUrlError'));
            });
        })
        //   const blob = new Blob([response.data], { type: 'application/pdf' });
  
      } catch (error) {
        console.error("Error al generar el PDF:", error);
      }
    };

    const fetchData = async ({ offset, limit, filtros = busqueda, order, orderBy } = {}) => {
      if (!busquedaIniciada) {
        return;
      }
      let ordenado = "DESC"
      let buscarPor = "saleDate"
  
      orderBy = orderBy || filtroOrder.ordenadoPor || buscarPor;
      order = order || filtroOrder.orden || ordenado;
  
      construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros, order, orderBy, grupoServicio);
  
      const payload = {
        // aaff_id: 7,
        filtros: { ...filtros},
        params: { page: offset, limit, order, orderBy },
      };
      setPayload(payload);
  
      if (refControladorAborto.current) {
        refControladorAborto.current.abort();
      }
      const controller = new AbortController();
      refControladorAborto.current = controller;
  
      try {
        setLoading(true);
        const response = await getSalesProperties(payload, { signal: controller.signal });
        
        if (!controller.signal.aborted) {
          const { meta, data } = response;
          setListaVentas(data);
          setData({
            meta,
            rows: formatData(data),
          });
        }
      } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
        } else {
          console.log(error);
        }
      } finally {
        // Solo limpiar loading si es la última petición
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };
    const color = ['#0767A2', '#B96800', '#409FD9', '#EE8D11', "", "#77AF6E", "#77D860", "#ffd752", "#f8de87"];
    const formatData = (data) => {
      console.log(data)
      return data.map((row) => {
        const tienePendientesEnAno = (ano) => {
          const pendientesEnAno = row.properties?.sales?.some((sale) => {
            const sinVisitar = sale.detailsCae?.some((detail) => detail.visitada === false);
            const coincideWorkcenter = !row.workcenter_id || sale.workcenter_id === row.workcenter_id;
            const esDelAno = new Date(sale.saleDate).getFullYear() === ano;
            return sinVisitar && coincideWorkcenter && esDelAno;
          });
          if (!pendientesEnAno || ano < 2024) return pendientesEnAno;

          const hayPendienteAnteriorSinUnrealized = row.properties?.sales?.some((sale) => {
            const sinVisitar = sale.detailsCae?.some((detail) => detail.visitada === false);
            const noEsUnrealized = !sale.detailsCae?.some((detail) => detail.unRealized === true);
            const coincideWorkcenter = !row.workcenter_id || sale.workcenter_id === row.workcenter_id;
            const anoSale = new Date(sale.saleDate).getFullYear();
            return sinVisitar && noEsUnrealized && coincideWorkcenter && anoSale >= 2024 && anoSale < ano;
          });
          return !hayPendienteAnteriorSinUnrealized;
        };
        return {
          color: user.rol === "AAFF" && row.serviceprops.id === 6 ? '#0767A2' : user.rol === "AAFF" && row.serviceprops.id === 7 ? '#B96800' : color[row.serviceprops.id - 1],
          primeraPendiente: new Date(row.properties.sales.filter(sale => sale.detailsCae.some(detail => detail.visitada === false)).map(sale => (sale.saleDate))[0]).getFullYear(),
          tienePendientesEnAno,
          razonSocial: row.aaff.razonSocial,
          saleDate: new Date(row.saleDate).getFullYear(),
          servicio: user.rol === "AAFF" && row.serviceprops.nombre === "SPA Implantación" ? "CAE Implantación" : user.rol === "AAFF" && row.serviceprops.nombre === "SPA Renovación" ? "CAE Renovación" : row.serviceprops.nombre,
          nif: row.properties.nif,
          nif_aaff: row.aaff.nif,
          finca: row.properties,
          comunidad: row.workcenters === null ? row.properties.razonSocial : row.workcenters.razonSocial,
          codigoPostal: row.properties.codigoPostal,
          createdAt: row.createdAt,
          documentos: row,
          noVisita: row,
          servicioRealizado: Object.keys(row.detailsLopd).length > 0 ? row.saleDate : row,
          hacerVisita: user.rol !== 'COMM' && user.rol !== 'AAFF' ? row : null,
          isWorkcenter: row.workcenters ? true : false
        }
      });
    };

    const filtrarDatos = (filtros) => {
      setBusqueda(filtros)
      setBusquedaActiva(true);
      setBusquedaIniciada(true);
      // fetchData({ offset: 1, limit: limite, filtros });
    }

    useEffect(() => {
        return () => {
          if (refControladorAborto.current) {
            refControladorAborto.current.abort();
          }
        };
      }, []);

  return (
    <>
      <BreadCrumb
        rutas={[{ path: `/comunidades`, label: t('title') }]}
        style={{ margin: "0 10px" }}
      />
      <div className="pageContent tableContainer" style={{ margin: 0 }}>
        <FiltrosComunidadesTechServ
          onFilter={filtrarDatos}
          clearFilter={clearFilters}
          filtrosIniciales={busqueda}
        />
        <div>
          <ExportarListaComunidades payload={payload} disabled={loading} />
        </div>
        <div className="tableWrapper">
          <Box className="pageContent" style={{ margin: 0 }}>
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data.rows}
                isLoading={loading}
                headers={comunidadesRows}
                fetcher={fetchData}
                currentPage={data.current_page}
                meta={data.meta}
                totalItems={data.total}
                totalPages={data.totalPages}
                nextPage={data.next_page}
                filtros={busqueda}
                busquedaActiva={busquedaActiva}
                setBusquedaActiva={setBusquedaActiva}
                clearFilterActivo={clearFilterActivo}
                setClearFilterActivo={setClearFilterActivo}
                mensaje={t('noInfo')}
              />
            </Box>
          </Box>
        </div>
      </div>
      <style jsx="true">{`
        .tableContainer table tbody th.docs {
          text-align: center;
        }
        .tableContainer table tbody td {
          padding: 0;
        }
      `}</style>
    </>
  );
}
 
export default ComunidadesServicio;